var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"header container-fluid"},[_c('div',{staticClass:"row"},[_c('h1',[_vm._v(_vm._s(_vm.greeting()))]),(_vm.curUser)?_c('p',[_vm._v(_vm._s(_vm.curUser))]):_vm._e()])]),_c('div',{staticClass:"container d-flex justify-content-center"},[_c('div',{staticClass:"float-form"},[_c('FloatAssignForm')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }